module.exports = __webpack_public_path__ + "img/valentis_logo.bf7f1d24.svg";